export default __webpack_public_path__ + "static/media/logo-masorden-gris-small.4b1e1613.svg";